import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, FlameIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, PRODUCT_IMAGE } from '../data/hero';
export function Hero() {
  return <header className="relative overflow-hidden bg-obsidian text-white" data-id="element-112" data-mp="9lbkfd8rfxje">
      <div className="mx-auto grid max-w-6xl gap-y-7 px-5 pb-14 pt-8 text-center lg:grid-cols-[1fr_1.1fr] lg:gap-x-12 lg:gap-y-8 lg:pb-20 lg:pt-16 lg:text-left" style={{
      paddingTop: "0px",
      paddingBottom: "10px",
      gap: "13px"
    }} data-id="element-113" data-mp="4mrsmw7hjrj4">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-114" data-mp="xb5rtfab8tw9">
          <h1 className="mt-4 font-display text-[46px] font-extrabold uppercase leading-[0.92] tracking-tight sm:text-6xl lg:text-[76px]" style={{
          fontSize: "36px"
        }} data-id="element-115" data-mp="sa9s7dwzrtwn">
            Entraînez-vous plus intelligemment.
            <br data-id="element-116" data-mp="3d2tnz8hi2ie0" />
            Alimentez-vous mieux.
            <br data-id="element-117" data-mp="381xkux4z309n" />
            <span className="text-electric" data-id="element-118" data-mp="381e1dbzoc3ti">Exécutez avec confiance.</span>
          </h1>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-white/70 sm:text-lg lg:mx-0" data-id="element-119" data-mp="3j898df6ywfql">
            Un système complet pour organiser votre préparation, de vos premières séances jusqu'à la ligne d'arrivée.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-120" data-mp="39cfofaqx5jys">
          <img src={PRODUCT_IMAGE} alt="LE SYSTÈME TRIATHLON LONGUE DISTANCE™ sur ordinateur portable avec les quatre bonus pratiques sur tablettes" width={1536} height={1024} fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[620px] drop-shadow-[0_30px_40px_rgba(20,125,255,0.18)]" data-id="element-121" data-mp="359j6znd47twf" />
        </motion.div>

        <div className="lg:col-start-1 lg:row-start-2" data-id="element-122" data-mp="2lkqwhvi0exid">
          <p className="text-sm font-semibold text-white" data-id="element-123" data-mp="2lk8wqow5215p">Méthode complète en 6 volumes + 4 bonus pratiques</p>
          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-white/60 lg:justify-start" data-id="element-124" data-mp="s3co0h6r7vtq">
            <span className="flex items-center gap-1" data-id="element-125" data-mp="ic891hh2wayw">
              <span className="flex text-ember" aria-label="4,9 sur 5 étoiles" data-id="element-126" data-mp="icrn2n3lyf7n">
                {Array.from({
                length: 5
              }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-127" data-mp="1b0njrrt6g74f" data-mpi={k} />)}
              </span>
              <span className="font-semibold text-white" data-id="element-128" data-mp="161b01fxlrg62">4,9/5</span>
            </span>
            <span data-id="element-129" data-mp="112g6biy3k776">+500 athlètes d'élite et amateurs</span>
            <span className="inline-flex items-center gap-1" data-id="element-130" data-mp="110wovp0pfq3t">
              <ZapIcon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-131" data-mp="x1w789tyqtie" /> Accès immédiat
            </span>
          </p>

          <div className="mt-6 flex justify-center lg:justify-start" data-id="element-132" data-mp="3luiaiu6w15my">
            <CTAButton href="#pricing" data-id="element-133" data-mp="3hr3rdunnk95a">Découvrez le système complet</CTAButton>
          </div>

          <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-134" data-mp="1xa41h7xz88gg">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[0.04] px-3 py-1.5 text-xs font-medium text-white/80" data-id="element-135" data-mp="218toztcqb6dt">
                <Icon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-136" data-mp="2b1hgq9ouqk5o" />
                {label}
              </li>)}
          </ul>

          <div className="mt-6 flex flex-col items-center gap-2 lg:items-start" data-id="element-137" data-mp="2g257qvd2z0zw">
            <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/35 bg-ember/10 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ember" data-id="element-138" data-mp="2kx2hk4i6pedu">
              <FlameIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-139" data-mp="2tyaa05y0rl00" />
              Offre de lancement limitée · Le prix reviendra à son tarif habituel
            </p>
            <p className="flex items-center gap-1.5 text-xs text-white/45" data-id="element-140" data-mp="zkra4pginqbj">
              <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-141" data-mp="4b461q1btyhv" />
              25 personnes consultent ce produit en ce moment
            </p>
          </div>
        </div>
      </div>
    </header>;
}